import type { ReactNode } from "react";
import { mfgMdInputClass } from "@/components/manufacturing/manufacturingSurfaceClasses";
import type { MfgMaterialUseResolveMode } from "@/lib/manufacturing/types";

function FieldHint({ children }: { children: ReactNode }) {
  return <span className="mt-1 block text-xs text-gray-500 dark:text-zinc-400">{children}</span>;
}

export function ManufacturingMaterialUseResolveModeFields({
  mode,
  setMode,
  channel,
  setChannel,
  disabled,
}: {
  mode: MfgMaterialUseResolveMode;
  setMode: (v: MfgMaterialUseResolveMode) => void;
  channel: string;
  setChannel: (v: string) => void;
  disabled: boolean;
}) {
  return (
    <>
      <label className="block text-sm sm:col-span-2">
        <span className="font-medium text-gray-700 dark:text-zinc-300">Resolve mode</span>
        <select
          className={mfgMdInputClass + " mt-1 w-full"}
          value={mode}
          disabled={disabled}
          onChange={(e) =>
            setMode(e.target.value === "finish_variant" ? "finish_variant" : "substitute")
          }
        >
          <option value="substitute">Substitute (interchangeable SKUs)</option>
          <option value="finish_variant">Finish variant (color family + variant ledger)</option>
        </select>
        <FieldHint>
          Finish variant keeps the BOM color-blind; consumption posts a variant deficit then
          reattributes to a color SKU when modifiers match.
        </FieldHint>
      </label>
      {mode === "finish_variant" ? (
        <label className="block text-sm sm:col-span-2">
          <span className="font-medium text-gray-700 dark:text-zinc-300">Finish channel</span>
          <input
            className={mfgMdInputClass + " mt-1 w-full font-mono"}
            value={channel}
            placeholder="siding | roof | trim | paint"
            disabled={disabled}
            onChange={(e) => setChannel(e.target.value)}
          />
          <FieldHint>Matched to deal/build color modifiers (e.g. siding_color → siding).</FieldHint>
        </label>
      ) : null}
    </>
  );
}
